import React from 'react'
import { flattenMessages } from '../../utils'

let wordings

export function setWordings(w) {
  wordings = flattenMessages(w)
  console.log(wordings)
}

export default function T({ children }) {
  return (
    <div dangerouslySetInnerHTML={{ __html: (wordings && wordings[children]) || children }} />
  )
}
